export const HEADS = ["Type", "name", "description", "active", "Assistants #"];